import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import {SharedSettings} from "../models/shared-settings";
import {Observable} from "rxjs";
import {url} from "../helpers/url";
import {ActivityBlockingService} from "../services/activity-blocking.service";
import {BlobDocumentInfo} from "../models/blob-document-info";

@Injectable({
  providedIn: 'root'
})
export class BlobStorageService {
    constructor(private http: HttpClient,
                private settings: SharedSettings,
                private activityService: ActivityBlockingService) { }

    GetBlobDocumentsInfo(params: HttpParams): Observable<BlobDocumentInfo[]> {
        return this.http.get<BlobDocumentInfo[]>(this.settings.apiBaseUrl + url`blobStorage`, { params });
    }

    GetBlobFile(fileId: string): Observable<HttpResponse<Blob>> {
        return this.http.get(this.settings.apiBaseUrl + url`blobStorage/${fileId}`, {
            responseType: 'blob',
            observe: 'response'
        })
    }

    BulkDownload(blobPaths: string[]): Observable<HttpResponse<Blob>> {
        return this.http.post(this.settings.apiBaseUrl + url`blobStorage/bulkDownload`
            , blobPaths
            ,{ responseType: 'blob', observe: 'response'}
        );
    }

    DeleteBlobFile(fileId: string) {
        return this.http.delete(this.settings.apiBaseUrl + url`blobStorage/${fileId}`);
    }
}
